import { AnimatedModalProps } from '../animated-modal/animated-modal.js';
import { animatedModal, Modal } from '../index.js';

interface SimpleModalProps {
    children?: any;
    text?: string;
    className?: string;
    title?: string;
    buttons?: {
        text: string;
        action?: AnyFunction;
        style?: any;
        color?: string;
        disabled?: boolean;
        variant?: string;
        testId?: string;
    }[];
}

type Props = SimpleModalProps & AnimatedModalProps;

const SimpleModal: FC<Props> = ({ buttons, text, onClose, className = '', children, title }) => {
    if (!buttons || buttons.length === 0) {
        buttons = [
            {
                text: 'OK',
                color: 'primary',
            },
        ];
    }

    return (
        <Modal className={className} onClose={onClose} buttons={buttons} title={title}>
            {text ? <p>{text}</p> : children}
        </Modal>
    );
};

export default animatedModal<SimpleModalProps>(SimpleModal, { className: 'simple-modal', narrow: true });
